const setResetKey = (keyList = {}, key) => {
  if (key === undefined || key === null || key === '') return
  if (typeof key === 'boolean') return
  keyList[key] = true
}

const setResetKeyList = (keyList = {}, data = {}) => {
  Object.keys(data || {}).forEach((key) => {
    setResetKey(keyList, key)
    setResetKey(keyList, data[key])
    let valueKeyList = String(data[key] || '').split('.')
    if (valueKeyList.length > 1) {
      setResetKey(keyList, valueKeyList[valueKeyList.length - 1])
    }
  })
}

export const getFormGroupResetKeyList = ({
  key,
  formDataName,
  componentName,
  dynamicName,
  groupName,
  mapDataKey = {},
  mapData = {},
  mapParam = {},
  mapReceive = {},
} = {}) => {
  let keyList = {}

  ;[key, formDataName, componentName, dynamicName, groupName].forEach(
    (resetKey) => setResetKey(keyList, resetKey),
  )
  setResetKeyList(keyList, mapDataKey)
  setResetKeyList(keyList, mapData)
  setResetKeyList(keyList, mapParam)
  setResetKeyList(keyList, mapReceive)

  return keyList
}

const getParentPath = (key = '') => {
  let keyList = String(key || '').split('.')
  if (keyList.length <= 1) return ''
  keyList.pop()
  return keyList.join('.')
}

export const getActionResetKeyList = ({
  actionList = [],
  allFormGroup = [],
} = {}) => {
  let keyList = {}

  actionList.forEach((action = {}) => {
    if (action.name !== 'resetData' || action.resetType !== 'form') return
    let formList = action.form || []
    formList.forEach((formKey) => {
      let form = allFormGroup.find(({ key }) => key === formKey) || {}
      let groupList = form.isGroup ? form.groupData || [] : [form]
      groupList.forEach((group = {}) => {
        let resetKeyList = getFormGroupResetKeyList(group)
        Object.keys(resetKeyList).forEach((key) => setResetKey(keyList, key))
      })
    })
  })

  return keyList
}

const isInResetScope = (key = '', resetScopeList = []) => {
  if (!key) return false
  return resetScopeList.some(
    (scope) => key === scope || String(key).startsWith(`${scope}.`),
  )
}

const getResetScopeList = (actionList = [], allFormGroup = []) => {
  let scopeList = []
  const addScope = (key = '') => {
    if (!key || scopeList.includes(key)) return
    scopeList.push(key)

    let parent = getParentPath(key)
    if (parent && !scopeList.includes(parent)) {
      scopeList.push(parent)
    }
  }

  let resetKeyList = getActionResetKeyList({ actionList, allFormGroup })
  Object.keys(resetKeyList).forEach(addScope)
  return scopeList
}

const getApiList = (buttonAction = {}, allApiGroup = []) => {
  let apiList = []
  let crudApiGroup = buttonAction?.crud?.apiGroup || []
  let apiSaveUpdate = buttonAction?.crud?.apiSaveUpdate || []

  crudApiGroup.forEach((api = {}) => {
    apiList.push(api)
  })
  apiSaveUpdate.forEach((api = {}) => {
    ;[api.get, api.found, api.notfound].forEach((item) => {
      if (item) apiList.push(item)
    })
  })
  apiList.forEach((api = {}) => {
    let fetchSuccess = api.fetchSuccess || {}
    Object.keys(fetchSuccess).forEach((key) => {
      let foundApi = allApiGroup.find((item) => item.key === key)
      if (foundApi) apiList.push(foundApi)
    })
  })

  return apiList
}

export const getActionResponseResetKeyList = ({
  buttonAction = {},
  actionList = [],
  allFormGroup = [],
  allApiGroup = [],
} = {}) => {
  let keyList = {}
  let resetScopeList = getResetScopeList(actionList, allFormGroup)
  if (resetScopeList.length === 0) return keyList

  const setScopedResetKeys = (...keys) => {
    let isScoped = keys.some((key) => isInResetScope(key, resetScopeList))
    if (!isScoped) return
    keys.forEach((key) => setResetKey(keyList, key))
  }

  let apiGroup = getApiList(buttonAction, allApiGroup)
  apiGroup.forEach((api = {}) => {
    ;[api.key, api.tableKey, api.bulkData?.key].forEach((key) => {
      setScopedResetKeys(key)
    })
    Object.values(api.response || {}).forEach((key) => {
      setScopedResetKeys(key, String(key || '').split('.').pop())
    })

    let dataTable = api.dataTable || []
    dataTable.forEach((item = {}) => {
      setScopedResetKeys(
        item.value,
        item.element,
        item.key,
        item.response,
        String(item.response || '').split('.').pop(),
        item.dynamicName,
      )
    })
    let formDataList = api.formDataList || []
    formDataList.forEach((form = {}) => {
      let formKeyList = getFormGroupResetKeyList(form)
      setScopedResetKeys(form.key, ...Object.keys(formKeyList))
    })
  })

  return keyList
}
